// extracted by mini-css-extract-plugin
export var phone = "_18-0";